module.exports = __webpack_public_path__ + "HugeData_Banner.png?065e9608c49770a935d8de26c52f6f79";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Solution/HugeData/HugeData_Banner.png
// module id = 58
// module chunks = 0